import React from 'react'
import CancelReturnDashboard from '../../components/home/CancelReturnDashboard'
import InquiryDashboard from '../../components/home/InquiryDashboard'
import RevenueDashboard from '../../components/home/RevenueDashboard'
import ReviewDashboard from '../../components/home/ReviewDashboard'
import SalesDeliveryDashboard from '../../components/home/SalesDeliveryDashboard'
import UserDashboard from '../../components/home/UserDashboard'
import ContentHeader from '../../components/shared/ContentHeader'
import '../../styles/home.scss'

const HomePage = () => {
  return (
    <>
      <ContentHeader title={'대시보드'} />
      <div className="dashboard-container">
        <div className="dashboard-main-layout">
          {/* 왼쪽 영역 */}
          <div className="dashboard-left-column">
            {/* 판매/배송 */}
            <div
              className="dashboard-card"
              style={{ border: '1px solid #d1d1d1' }}
            >
              <SalesDeliveryDashboard />
            </div>

            {/* 취소/반품 & 문의 */}
            <div className="dashboard-row-inner">
              <div className="dashboard-card">
                <CancelReturnDashboard />
              </div>
              <div className="dashboard-card">
                <InquiryDashboard />
              </div>
            </div>

            {/* 리뷰 */}
            <div className="dashboard-card">
              <ReviewDashboard />
            </div>
          </div>

          {/* 오른쪽 영역 */}
          <div className="dashboard-right-column">
            {/* 가입 / 유입 통계 */}
            <div className="dashboard-card user-card">
              <UserDashboard />
            </div>

            {/* 매출/판매 통계 */}
            <div className="dashboard-card revenue-card">
              <RevenueDashboard />
            </div>
          </div>
        </div>

        {/* 혜택 - 전체 너비로 배치 - 7월 종료 */}
        {/* <div className="dashboard-full-width">
          <div className="dashboard-card">
            <BenefitDashboard />
          </div>
        </div> */}
      </div>
    </>
  )
}

export default HomePage
